import { css, cx } from 'emotion';
import {
	lightGrey,
	headingSmallLight,
	textBlock,
	mobileMaxWidthBreakpoint,
} from 'inside-out/global-styles';
import MediaIcon from 'inside-out/images/media-icon.svg';
import MediaIconMobile from 'inside-out/images/media-icon-mobile.svg';

const padding = 24;

export const wrapperLinkStyle = css({
	textDecoration: 'none',
	display: 'block',
});

export const wrapperStyle = (background, hasVideo) => {
	const baseCSS = {
		position: 'relative',
		textDecoration: 'none',
		border: `1px solid ${lightGrey}`,
		borderRadius: '6px',
		backgroundColor: '#fff',
		boxSizing: 'border-box',
	};
	if (background) {
		return css({
			...baseCSS,
			padding: `${padding}px`,
			paddingTop: '56.159420289855072%',
			position: 'relative',
			zIndex: '1',
			height: '100%',
			'&:after': {
				borderRadius: '6px 6px 0 0',
				content: "' '",
				display: 'block',
				position: 'absolute',
				top: 0,
				left: 0,
				width: '100%',
				paddingTop: '56.159420289855072%',
				...(hasVideo
					? {
							background: `url(${MediaIcon}), linear-gradient(
						rgba(0, 0, 0, 0.3), 
						rgba(0, 0, 0, 0.3)
					), url('${background}')`,
							backgroundRepeat: 'no-repeat',
							backgroundPosition: 'center center, center center, top center',
							backgroundSize: '56px 56px, cover, cover',
							[`@media (max-width: ${mobileMaxWidthBreakpoint}px)`]: {
								backgroundImage: `url(${MediaIconMobile}), url('${background}')`,
								backgroundSize: '40px 40px, cover, cover',
							},
					  }
					: {
							background: `linear-gradient(
						rgba(0, 0, 0, 0.3), 
						rgba(0, 0, 0, 0.3)
					), url('${background}')`,
							backgroundRepeat: 'no-repeat',
							backgroundPosition: 'center center, top center',
							backgroundSize: 'cover, cover',
					  }),
			},
			'& h1': {
				marginTop: '24px',
			},
			button: {
				filter: 'brightness(2)',
			},
		});
	}

	return css({
		...baseCSS,
		padding: `${padding}px`,
		position: 'relative',
		zIndex: '1',
		height: '100%',
		'& > img': {
			display: 'block',
			marginBottom: '18px',
		},
	});
};

export const titleStyle = cx(
	headingSmallLight,
	css({
		marginBottom: '11px',
	})
);

export const bodyStyle = cx(
	textBlock,
	css({
		marginTop: 0,
		marginBottom: '10px',
	})
);

export const metaDateStyle = css({
	fontSize: '12px',
	lineHeight: '18px',
	margin: 0,
	color: '#8A8B8C',
});



// WEBPACK FOOTER //
// ./src/components/shared/cards/mediaCard/styles.js